/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Favorites/FavoritesSearch',[
    'jquery',
    './FavoritesManager',
    'global/all'
], function ($, FavoritesManager, Roc) {
    'use strict';

    var baseUrl;
    var pagination;
    var search;

    function addFriendEvt() {
        $(document).on('click', '.addFriendBtn', function () {
            var token = $(this).closest('.item').attr('data-token');
            $(this).html('Please wait...').attr('disabled', 'disabled');
            FavoritesManager.addFriend(token);
        });
    }

    function removeFriendBtn() {
        $(document).on('click', '.removeFriendBtn', function () {
            var token = $(this).closest('.item').attr('data-token');
            $(this).html('Please wait...').attr('disabled', 'disabled');
            FavoritesManager.deleteFriend(token);
        });
    }

    function expandHiddenLists() {
        $(document).on('click', '.expandHiddenListsBtn', function (e) {
            e.preventDefault();
            var $ul = $(this).closest('ul');
            $ul.find('li').each(function (i, obj) {
                var $obj = $(obj);

                if ($obj.hasClass('visuallyHidden')) {
                    $obj.removeClass('visuallyHidden');
                }
            });
            $(this).attr('data-old', $(this).html()).html('Collapse').removeClass('expandHiddenListsBtn').addClass('collapseHiddenLists');
        });
    }

    function collpaseHiddenLists() {
        $(document).on('click', '.collapseHiddenLists', function (e) {
            e.preventDefault();
            var $ul = $(this).closest('ul');
            var length = $ul.find('li').length;
            $ul.find('li').each(function (i, obj) {
                if (i >= 3 && i < length - 1) {
                    $(obj).addClass('visuallyHidden');
                }
            });
            $(this).html($(this).attr('data-old')).addClass('expandHiddenListsBtn').removeClass('collapseHiddenLists');
        });
    }

    function refreshControls(pg) {
        $('select#itemsSort option[data-sortby="' + pg.sortBy + '"][data-sortascending="' + pg.sortAscending + '"]').attr('selected', 'selected');
    }

    function refreshSearchResults(pg) {
        if (!pg) {
            pg = pagination;
        }

        $.get(baseUrl, { 'search': search, 'pageSize': pg.pageSize, 'page': pg.page, 'sortBy': pg.sortBy, 'sortAscending': pg.sortAscending }, function (data) {
            $('#results').html($('#results', data).html());
            refreshControls(pg);
        });
    }

    function friendAddedEvt(data) {
        if (data && data.Result === true) {
            var $btn = $('.item[data-token=\'' + data.token + '\']').find('button.addFriendBtn');
            $btn.removeClass('addFriendBtn').addClass('removeFriendBtn').html('Saved').prop('disabled', false);
        } else {
            Roc.UI.displayErrorPopup('There was an error while trying to add a friend. Please try again.');
        }
    }

    function friendDeletedEvt(data) {
        if (data && data.Result === true) {
            var $btn = $('.item[data-token=\'' + data.token + '\']').find('button.removeFriendBtn');
            $btn.removeClass('removeFriendBtn').addClass('addFriendBtn').html('Remember').prop('disabled', false);
        } else {
            Roc.UI.displayErrorPopup('There was an error while trying to remove your friend. Please try again.');
        }
    }

    function bindEvents() {
        addFriendEvt();
        removeFriendBtn();
        expandHiddenLists();
        collpaseHiddenLists();
        Roc.EventManager.bind(Roc.Events.favorites.ADD_FRIEND, friendAddedEvt);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_FRIEND, friendDeletedEvt);
    }

    function init(options) {
        baseUrl = options.baseUrl;
        search = options.search;
        pagination = Roc.Pagination.init(options, refreshSearchResults);
        refreshControls(pagination);
        bindEvents();
    }

    var FavoritesSearch = {
        init: init
    }

    Roc.Logger.debug('FavoritesSearch.js Loaded:', FavoritesSearch);

    return FavoritesSearch;
});
